import { render, staticRenderFns } from "./TcrmDetails.vue?vue&type=template&id=fab72ec6&"
import script from "./TcrmDetails.vue?vue&type=script&lang=js&"
export * from "./TcrmDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports